export default () => ({
    open: false,
    manuallyClosed: false,
    footer: null,
    init() {
        this.getStoredState();
        this.open = document.querySelector('body').classList.contains('neos-backend');
        this.footer = document.querySelector('footer');
    },
    getStoredState() {
        if (window.localStorage) {
            const key = this.getProductStorageKey();
            const localStorageRawData = window.localStorage.getItem(key);
            if (localStorageRawData !== null) {
                const localStorageData = JSON.parse(localStorageRawData);

                if (localStorageData.manuallyClosed) {
                    this.manuallyClosed = true;
                }
            }
        }
    },
    setStoredState() {
        if (window.localStorage) {
            const key = this.getProductStorageKey();
            const localStorageData = {
                manuallyClosed: this.manuallyClosed
            }
            const localStorageRawData = JSON.stringify(localStorageData);
            window.localStorage.setItem(key, localStorageRawData);
        }
    },
    getProductStorageKey() {
        let pathname = window.location.pathname;
        //strip share class
        pathname = pathname.replace(/\/?[^\/]+\/?$/, '');
        //strip language
        pathname = pathname.replace(/^\/([^-]+)-[^/]*\/(.*)/, '$1/$2');
        return 'floatingContactBox:product:' + pathname;
    },
    openContactBox: {
        ["@click"](event) {
            this.open = true;
        },
    },
    closeContactBox: {
        ["@click"](event) {
            this.open = false;
            this.manuallyClosed = true;
            this.setStoredState();
        },
    },
    events: {
        ['@scroll.window'](event) {
            //use footer height margin when detecting scroll to bottom
            if (window.innerHeight + window.scrollY >= document.documentElement.offsetHeight - this.footer.offsetHeight) {
                if (!this.manuallyClosed) {
                    this.open = true;
                }
            }
        },
        ['@downloadLinkClicked.window'](event) {
            if (!this.manuallyClosed) {
                this.open = true;
            }
        }
    }
});
